module.exports = __webpack_public_path__ + "static/media/drewlo.b79f14e5.png";